import { media } from '@app/ui'
import theme from '@app/ui/theme'
import styled from 'styled-components'

export const TableContainer = styled.div`
  width: 100%;
  margin-top: 5px;
  border-collapse: collapse;
  overflow-x: auto;
`

export const Table = styled.table`
  width: 99%;
  margin-top: 5px;
  border-collapse: collapse;
`

export const TableRowHead = styled.tr`
  border-bottom: 1px solid ${theme.colors.light};
`

export const TableHead = styled.thead``

export const TableHeadCol = styled.th`
  font-size: 13px;
  letter-spacing: 1px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding-bottom: 3px;
  text-align: left;
`

export const TableHeadColName = styled(TableHeadCol)`
  width: 30%;
`

export const TableHeadColRegion = styled(TableHeadCol)`
  width: 10%;
`

export const TableHeadColLastRated = styled(TableHeadCol)`
  width: 10%;
`

export const TableHeadColErLr = styled(TableHeadCol)`
  width: 10%;
  ${media.desktop} {
    display: none;
  }
`

export const TableHeadColHoles = styled(TableHeadCol)`
  width: 10%;
  ${media.desktop} {
    display: none;
  }
`

export const TableHeadColMap = styled(TableHeadCol)`
  width: 10%;
  ${media.desktop} {
    display: none;
  }
`

export const TableHeadColStatus = styled(TableHeadCol)`
  border-right: none !important;
`

export const TableBody = styled.tbody``

export const TableRow = styled.tr`
  &:last-child > * {
    border-bottom: none !important;
  }
`

export const TableCol = styled.td`
  font-size: 16px;
  color: rgba(0, 0, 0, 0.8);
  font-weight: 600;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  min-height: 30px;
  padding: 5px;
  padding-left: 0;

  &:first-child {
    text-align: left;
  }
  &:last-child {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
  }
`

export const TableColCenter = styled.div`
  justify-content: center;
  align-items: center;
  text-align: center;
`

export const TableColEnd = styled(TableCol)`
  justify-content: end;
  align-items: end;
  text-align: end;
`

export const TableColLogo = styled(TableCol)`
  width: 75px;
`

export const TableColLast = styled(TableCol)`
  border-right: none !important;
  width: 100px;
`

export const TableColStatus = styled.div`
  display: flex;
  flex-direction: row;
  .statusColor {
    width: 32px;
    height: 32px;
    border-radius: 18px;
  }

  .course-status-label {
    display: flex;
    flex-direction: column;
    text-align: left;
    color: #333;
    width: 80%;
  }
`

export const TableColErLr = styled(TableCol)`
  width: 10%;
  ${media.desktop} {
    display: none;
  }
`

export const TableColHoles = styled(TableCol)`
  width: 10%;
  ${media.desktop} {
    display: none;
  }
`

export const TableColMap = styled(TableCol)`
  width: 10%;
  ${media.desktop} {
    display: none;
  }
`

export const ClubHoleCount = styled.div`
  margin: 0 auto;
  border: 1px solid #ccc;
  width: 32px;
  height: 32px;
  gap: 2px;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.primary};
  font-weight: 600;
  font-size: 15px;
`

export const LockedHolesCount = styled.div`
  margin: 0 auto;
  padding: 0px 8px;
  border: 1px solid #ccc;
  min-width: 32px;
  width: auto;
  height: 32px;
  gap: 2px;
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.primary};
  font-weight: 600;
  font-size: 15px;
  border-radius: 8px;
`

export const EvaluationStatusText = styled.span`
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  padding-left: 10px;
`

export const EvaluationStatusDescription = styled.span`
  font-family: Roboto;
  font-size: 10px;
  font-weight: 400;
  padding-left: 10px;
`

export const HideOnTablet = styled.div`
  ${media.desktop} {
    display: none;
  }
`

export const ClubHoleContainer = styled.div`
  max-width: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
`
